import React, { useMemo, useState } from 'react';
import { Tabs, Tab, Typography, Container } from '@mui/material';
import UsersPart from './part/UsersPart';
import SamplersPart from './part/Samplers/SamplersPart';
import ConcoursPart from './part/ConcoursPart';
import PlanetPart from './part/PlanetPart';
import { UserDTO } from '../../models/userDTO';
import SupplierAdministrationPart from './part/SuppliersAdministration';
import AddressAdministrationPart from './part/AddressAdministrationPart';

interface TabPanelProps {
	index: number;
	value: number;
	children: React.ReactNode;
}

function TabPanel({ index, value, children }: TabPanelProps) {
	return (
		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}>
			{value === index && (
				<Typography component="div" sx={{ p: 3 }}>
					{children}
				</Typography>
			)}
		</div>
	);
}

const AdministrationScreen = (props: { user: UserDTO }) => {
	const [value, setValue] = useState(0);
	const { user } = props;
	const tabs = useMemo(
		() => [
			{ label: 'Utilisateurs', content: <UsersPart /> },
			{ label: 'Préleveurs', content: <SamplersPart /> },
			...(user?.extended_role !== 'PHF_SIEGE_ADMIN' ? [{ label: 'Planet', content: <PlanetPart /> }] : []),
			{ label: 'Concours', content: <ConcoursPart /> },
			{ label: 'Fournisseurs', content: <SupplierAdministrationPart user={user} /> },
			{ label: 'Adresses', content: <AddressAdministrationPart user={user} /> },
		],
		[user]
	);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	return (
		<Container maxWidth="xl" sx={{ mt: 4, mb: 4, flexDirection: 'row' }}>
			<Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
				{tabs.map((tab) => (
					<Tab key={tab.label} label={tab.label} />
				))}
			</Tabs>

			{tabs.map((tab, index) => (
				<TabPanel key={tab.label} value={value} index={index}>
					{tab.content}
				</TabPanel>
			))}
		</Container>
	);
};

export default AdministrationScreen;
